import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';

const phoneNumber = '01012341234';
const point = 5000;

const DeliveryManComplete = () => {
  return (
    <Style>
      <div className="content">
        <img src={`${process.env.PUBLIC_URL}/img/knock_logo.png`} width="14%" alt="logo" />

        <img
          className="success"
          src={`${process.env.PUBLIC_URL}/svg/ic_success.svg`}
          width={56}
          height={56}
          alt="출금완료"
        />
        <h1>
          {'출금이 완료되었어요\n'}
          <span className="pickupFont">노크노크</span>가{'\n기사님을 응원합니다!'}
        </h1>

        <h3>
          {`${phoneNumber}님\n현재 보유하신 응원지원금은\n`}
          <span className={`point pickupFont`}>{`${point.toLocaleString()}P`}</span>
          {` 입니다`}
        </h3>
      </div>
    </Style>
  );
};
export default DeliveryManComplete;

export const Style = styled.div`
  .pickupFont {
    color: #4dd2ae;
  }
  .deliveryFont {
    color: #ff8d23;
  }

  .content {
    position: relative;
    width: 100%;
    height: 100dvh;
    text-align: left;
    padding: 10px;
    background: #ffffff;
    white-space: pre-line;
  }
  img {
    padding-bottom: 6%;
  }
  img.success {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin-bottom: 4%;
  }
  h1 {
    font-size: 28px;
    line-height: 40px;
    color: #555555;
    font-family: 'Nunito Sans', 'Helvetica Neue', sans-serif;
    font-weight: 600;
    margin-bottom: 20%;
  }
  h3 {
    line-height: 30px;
    color: #555555;
    font-family: 'Nunito Sans', 'Helvetica Neue', sans-serif;
    margin: 0;
    font-weight: 500;
    span.delivery {
      background: #ffdcbb;
    }
    span.pickup {
      background: #d3f7ed;
    }
    span.point {
      font-size: 32px;
      line-height: 36px;
      background: none;
      font-weight: 700;
    }
  }
  .footer {
    width: calc(100% - 20px);
    position: fixed;
    bottom: 10%;
  }
  .box {
    background: #f6f6f6;
    border-radius: 10px;
    padding: 16px;
  }
  .box h4 {
    font-size: 16px;
    line-height: 30px;
    color: #979797;
    font-weight: 500;
    margin: 0;
  }
  button {
    margin-top: 12px;
    width: 100%;
    height: 14vh;
    background: #ff8d23;
    border: none;
    border-radius: 5px;
  }
  button.pickup {
    background: #4dd2ae;
  }
  button.delivery {
    background: #ff8d23;
  }
  button h1 {
    font-weight: 600;
    margin: 0;
    color: #ffffff;
  }
  button h3 {
    font-weight: 500;
    color: #ffffff;
  }
`;
